export const IntAssessHdrStore = {
  namespaced: true,
  state: {
    candidateInvited: undefined,
  },
  actions: {
    refershIntAssessHdr({ commit }, action) {
      commit("setIntAssessHdr", action.payload);
    }
  },
  mutations: {
    setIntAssessHdr(state, payload) {
      state.candidateInvited = payload;
    }
  },
  getters: {
    candidateInvited: state => {
      return state.candidateInvited;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/IntAssessHdrStore/IntAssessHdrStore.js